import { render, staticRenderFns } from "./SheBeiGaoJing.vue?vue&type=template&id=aa25f02a&scoped=true&"
import script from "./SheBeiGaoJing.vue?vue&type=script&lang=js&"
export * from "./SheBeiGaoJing.vue?vue&type=script&lang=js&"
import style0 from "./SheBeiGaoJing.vue?vue&type=style&index=0&id=aa25f02a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa25f02a",
  null
  
)

export default component.exports